import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-54a9e916")

_pushScopeId("data-v-54a9e916")
const _hoisted_1 = { class: "FTLOrderAdditional" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "FTLOrderAdditional__title" }, "Дополнительная информация", -1)
const _hoisted_3 = { class: "FTLOrderAdditional__body" }
const _hoisted_4 = { class: "body__row" }
const _hoisted_5 = { class: "body__column" }
const _hoisted_6 = { class: "body__block" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Способ оплаты", -1)
const _hoisted_8 = { class: "block__text" }
const _hoisted_9 = { class: "body__block margintop" }
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Объявленная стоимость", -1)
const _hoisted_11 = { class: "block__text" }
const _hoisted_12 = { class: "body__block margintop" }
const _hoisted_13 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Сторона оплаты", -1)
const _hoisted_14 = { class: "block__text" }
const _hoisted_15 = {
  key: 0,
  class: "body__block margintop"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Дата создания", -1)
const _hoisted_17 = { class: "block__text" }
const _hoisted_18 = { class: "body__block" }
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Примечания к отправке", -1)
const _hoisted_20 = { class: "block__text" }
const _hoisted_21 = { class: "body__block" }
const _hoisted_22 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Наименование товара", -1)
const _hoisted_23 = { class: "block__text" }
const _hoisted_24 = { class: "body__block" }
const _hoisted_25 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Объявленная цена", -1)
const _hoisted_26 = { class: "block__text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode("p", _hoisted_8, _toDisplayString(_ctx.FTLOrderState.data.payment_method), 1)
          ]),
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode("p", _hoisted_11, _toDisplayString(_ctx.FTLOrderState.data.declared_price
                                    ? `${_ctx.FTLOrderState.data.declared_price} ₸`
                                    : 'Не указана'), 1)
          ]),
          _createVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode("p", _hoisted_14, _toDisplayString(_ctx.FTLOrderState.data.payment_type), 1)
          ]),
          (_ctx.FTLOrderState.data.created_at)
            ? (_openBlock(), _createBlock("div", _hoisted_15, [
                _hoisted_16,
                _createVNode("p", _hoisted_17, _toDisplayString(_ctx.FTLOrderState.data.created_at), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_18, [
          _hoisted_19,
          _createVNode("p", _hoisted_20, _toDisplayString(_ctx.FTLOrderState.data.annotation || '-'), 1)
        ]),
        _createVNode("div", _hoisted_21, [
          _hoisted_22,
          _createVNode("p", _hoisted_23, _toDisplayString(_ctx.FTLOrderState.data.cargo_name || '-'), 1)
        ]),
        _createVNode("div", _hoisted_24, [
          _hoisted_25,
          _createVNode("p", _hoisted_26, _toDisplayString(_ctx.FTLOrderState.data.declared_price || '-'), 1)
        ])
      ])
    ])
  ]))
})